import React from 'react';
import * as S from '../styles';

export default function Ativacao({
  integrationStatus,
  editandoConexao,
  loading,
  form,
  handleChangeField,
  gerarToken,
  setEditandoConexao,
  salvarConexaoParcial,
  atualizarStatusAtivacao
}) {
  if (integrationStatus.ativo) {
    return (
      <>
        <S.formGrid>
          <label>
            <b>App ID:</b> {form.appId}
          </label>
          <label>
            <b>Business Account ID (WABA):</b> {form.businessAccountId}
          </label>
          <label>
            <b>Phone Number ID:</b> {form.phoneNumberId}
          </label>
          <label>
            <b>System User Access Token:</b> {form.systemUserAccessToken ? '••••••••••••••••••••••••••••••••' : ''}
          </label>
          <label>
            <b>Webhook Verify Token:</b> {form.webhookVerifyToken}
          </label>
          <label>
            <b>Status:</b> Ativado
          </label>
          {!editandoConexao && (
            <label>
              <button
                type='button'
                onClick={() => setEditandoConexao(true)}
                disabled={loading}
              >
                Editar Phone Number ID e Token
              </button>
            </label>
          )}
          {!editandoConexao && (
            <label>
              <button
                type='button'
                onClick={atualizarStatusAtivacao}
                disabled={loading}
              >
                {loading ? 'Atualizando...' : 'Atualizar Status de Ativacao'}
              </button>
            </label>
          )}
        </S.formGrid>

        {editandoConexao && (
          <S.templateTestBox>
            <h4>Editar Dados de Conexao</h4>
            <S.formGrid>
              <label>
                Phone Number ID *
                <input
                  type='text'
                  value={form.phoneNumberId}
                  onChange={(e) => handleChangeField('phoneNumberId', e.target.value)}
                  disabled={loading}
                />
              </label>
              <label>
                System User Access Token *
                <input
                  type='password'
                  value={form.systemUserAccessToken}
                  onChange={(e) => handleChangeField('systemUserAccessToken', e.target.value)}
                  disabled={loading}
                />
              </label>
            </S.formGrid>
            <S.templateActions>
              <button
                type='button'
                className='ghost'
                onClick={() => setEditandoConexao(false)}
                disabled={loading}
              >
                Cancelar
              </button>
              <button
                type='button'
                className='primary'
                onClick={salvarConexaoParcial}
                disabled={loading}
              >
                {loading ? 'Processando...' : 'Salvar e Solicitar Nova Ativacao'}
              </button>
            </S.templateActions>
          </S.templateTestBox>
        )}
      </>
    );
  }

  return (
    <S.formGrid>
      <label>
        App ID *
        <input
          type='text'
          value={form.appId}
          onChange={(e) => handleChangeField('appId', e.target.value)}
          disabled={loading}
        />
      </label>
      <label>
        App Secret *
        <input
          type='password'
          value={form.appSecret}
          onChange={(e) => handleChangeField('appSecret', e.target.value)}
          disabled={loading}
        />
      </label>
      <label>
        Business Account ID (WABA) *
        <input
          type='text'
          value={form.businessAccountId}
          onChange={(e) => handleChangeField('businessAccountId', e.target.value)}
          disabled={loading}
        />
      </label>
      <label>
        Phone Number ID *
        <input
          type='text'
          value={form.phoneNumberId}
          onChange={(e) => handleChangeField('phoneNumberId', e.target.value)}
          disabled={loading}
        />
      </label>
      <label>
        System User Access Token *
        <input
          type='password'
          value={form.systemUserAccessToken}
          onChange={(e) => handleChangeField('systemUserAccessToken', e.target.value)}
          disabled={loading}
        />
      </label>
      <label>
        Webhook Verify Token *
        <S.inlineInput>
          <input
            type='text'
            value={form.webhookVerifyToken}
            onChange={(e) => handleChangeField('webhookVerifyToken', e.target.value)}
            disabled={loading}
          />
          <button
            type='button'
            onClick={() => handleChangeField('webhookVerifyToken', gerarToken())}
            disabled={loading}
          >
            Gerar
          </button>
        </S.inlineInput>
      </label>
    </S.formGrid>
  );
}
